import { render, staticRenderFns } from "./BackImageTrack.vue?vue&type=template&id=484564bf&scoped=true&"
import script from "./BackImageTrack.vue?vue&type=script&lang=js&"
export * from "./BackImageTrack.vue?vue&type=script&lang=js&"
import style0 from "./BackImageTrack.vue?vue&type=style&index=0&id=484564bf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484564bf",
  null
  
)

export default component.exports